// extracted by mini-css-extract-plugin
module.exports = {"header":"_2WAMeMniIXtFbjgEQym1Kr","dialog":"_2QPtLfwmOl0laHa1Slu_Bz"};